export default (animation=true,interval=15)=>{
    if(!animation){
        window.scrollTo(0,0);
        return;
    }
    let timer = null;
    let num = window.scrollY/interval;
    cancelAnimationFrame(timer);
    timer = requestAnimationFrame(function fn() {
        if (window.scrollY> 0) {
            window.scrollTo(0,window.scrollY-num);
            timer = requestAnimationFrame(fn);
        } else {
            cancelAnimationFrame(timer);
        }
    })
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/webawesome/libs/utils/tools/slideToTop.js
// module id = null
// module chunks = 